import { render, staticRenderFns } from "./RDPLogin.vue?vue&type=template&id=5b05788e&scoped=true&"
import script from "./RDPLogin.vue?vue&type=script&lang=ts&"
export * from "./RDPLogin.vue?vue&type=script&lang=ts&"
import style0 from "./RDPLogin.vue?vue&type=style&index=0&id=5b05788e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05788e",
  null
  
)

export default component.exports